import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

export const LaunchBulkUnwasteTickets = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const canBulkUnwasteTickets = useUserHasFeature(Feature.BulkUnwasteTickets);

  if (!canBulkUnwasteTickets) {
    return null;
  }

  return (
    <PosDropdownItem
      key="UnwasteTicketsItem"
      onClick={onClick}
      disabled={disabled}
    >
      <Content id={ContentId.UnwasteTickets} />
    </PosDropdownItem>
  );
};
